// extracted by mini-css-extract-plugin
export default {"locationContainer":"styles_locationContainer__tKve9"};